module.exports = __webpack_public_path__ + "img/logo.db21efd2.png";